// app-pages/PaymentsPage/CryptoPaymentsModal/queries/useCryptoEstimate.ts
"use client";
import { useQuery } from "@tanstack/react-query";
import { fetch } from "libs";

async function fetchCryptoEstimate(amount: number, currencyTo: string | null): Promise<any> {
  const apiKey = "JAMG3E6-YB0MX8M-N96985V-R31BTXG";
  const response = await fetch(
    `https://api-sandbox.nowpayments.io/v1/estimate?amount=${amount}&currency_from=usd&currency_to=${currencyTo}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": apiKey,
      },
    }
  );

  return response;
}

export default function useCryptoEstimate(
  price: number,
  selectedCurrency: string | null,
  opts = {}
) {
  return useQuery({
    queryKey: ["cryptoEstimate", price, selectedCurrency],
    queryFn: () => fetchCryptoEstimate(price, selectedCurrency),
    enabled: !!price && !!selectedCurrency,
    ...opts,
  });
}
